export default {
  id: 166,
  title: 'Target #166 - Flow',
  url: 'https://cssbattle.dev/play/166',
  colors: ['#D86F45', '#FDFBF8'],
  solution:
    '<a a><a b><a c><a d><style>[a],[b]{left:100}[b],[c]{top:0}[a],[c]{height:100;border-radius:0 0 9in 9in}[a],[b],[c]{border-radius:0 0 9in 9in}[c],[d]{left:160;width:80}body{background:#d86f45}a{position:fixed;background:#fdfbf8;color:#fdfbf8}[a]{top:170;width:200}[b]{width:30;height:125;box-shadow:170px 0}[d]{top:130;height:80;border-radius:9in;box-shadow:-85px 0 0 -25px,-55px 0 0 -25px #d86f45,55px 0 0 -25px #d86f45,85px 0 0 -25px}</style>',
}
